module.exports = __webpack_public_path__ + "img/Taya-Pinas.d6276721.png";